import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import moment from 'moment';

import {
  KeyboardDatePicker
} from '@material-ui/pickers';

import { withStyles } from '@material-ui/core/styles';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  ListItemText,
  TablePagination,
  Paper,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@material-ui/core';

import agm from '../../services/agm';
import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.cyan[400],
    '&$checked': {
      color: colors.cyan[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultOccurenceTypes = {
  corretiva: true,
  preventiva: true,
  avcb: true,
  pendencia: true
}

const defaultDependencies = {
  loaded: false,
  types: [],
  contracts: [],
  regions: [],
  teams: [],
  categories: [],
  technicians: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter, openView, changeCenter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(100);
  const [occurenceTypes, setOccurenceTypes] = useState(defaultOccurenceTypes);
  const [contract, setContract] = useState(3);
  const [cpccpa, setCpccpa] = useState(0);

  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState([]);

  const [technicians, setTechnicians] = useState([]);
  const [techniciansId, setTechniciansId] = useState([]);

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(
      value,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  }

  const changeCategory = (event) => {
    var ids = [];
    event.target.value.forEach(nome => {
      dependencies.categories.forEach(cat => {
        if (cat.nome == nome) {
          ids.push(cat.id);
        }
      });
    });
    setCategory(event.target.value);
    setCategoryId(ids);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      ids,
      techniciansId);
  }

  const changeTechnicians = (event) => {
    var ids = [];
    event.target.value.forEach(nome => {
      dependencies.technicians.forEach(tecn => {
        if (tecn.nome == nome) {
          ids.push(tecn.id);
        }
      });
    });
    setTechnicians(event.target.value);
    setTechniciansId(ids);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      ids);
  }

  const changeContract = (event) => {
    setContract(event.target.value);
    var base = {};
    for (let index = 0; index < dependencies.contracts.length; index++) {
      const element = dependencies.contracts[index];
      if (element.id == event.target.value) {
        base = { lat: parseFloat(element.latitude), lng: parseFloat(element.longitude) };
      }
    }
    setPage(0);
    changeCenter(base);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      event.target.value,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  }

  const changeCPACPC = (event) => {
    setCpccpa(event.target.value);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      event.target.value,
      categoryId,
      techniciansId);
  }

  const changeOccurenceTypes = (event) => {
    const value = { ...occurenceTypes, [event.target.name]: event.target.checked };
    setOccurenceTypes(value);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      contract,
      value,
      cpccpa,
      categoryId,
      techniciansId);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      event.target.value,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      event.target.value,
      0,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      newPage,
      rows,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(
      startDateTime,
      endDateTime,
      query,
      keyword,
      page,
      rowsPerPage,
      contract,
      occurenceTypes,
      cpccpa,
      categoryId,
      techniciansId);
  };


  const loadDependencies = ((value) => {
    agm.get('/ocorrencias/agenda/dependencias', {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          contracts: response.data.contratos,
          types: response.data.tipos,
          categories: response.data.categorias,
          technicians: response.data.tecnicos
        });
      } else {
        return defaultDependencies;
      }
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    if (!dependencies.loaded) {
      loadDependencies();
    }
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">

            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/sup/main">ASSISTÊNCIA TÉCNICA</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Agenda</b>
            </Typography>


          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={2}>
                            <Grid item
                              md={4}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="contract">Contratos</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Contratos"
                                  variant="outlined"
                                  id="contract"
                                  name="contract"
                                  value={contract}
                                  onChange={changeContract}
                                  inputProps={{
                                    name: 'contract',
                                    id: 'contract',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                  {dependencies.contracts.map((contract) => (
                                    <MenuItem key={contract.id} value={contract.id}>{contract.empresa.nome} - {contract.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={2}
                              xs={12}>

                              <KeyboardDatePicker
                                margin="none"
                                cancelLabel="Cancelar"
                                id="startDateTime"
                                name="startDateTime"
                                label="Data Inicial"
                                format="DD/MM/YYYY"
                                value={startDateTime}
                                inputVariant="outlined"
                                onChange={changeStartDatetime}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="cpccpa">CPC / CPA</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="CPC / CPA"
                                  variant="outlined"
                                  id="cpccpa"
                                  name="cpccpa"
                                  value={cpccpa}
                                  onChange={changeCPACPC}
                                  inputProps={{
                                    name: 'cpccpa',
                                    id: 'cpccpa',
                                  }}
                                >
                                  <MenuItem key={0} value={0}>&nbsp;</MenuItem>
                                  <MenuItem key={1} value={1}>No CPA</MenuItem>
                                  <MenuItem key={2} value={2}>No CPA -1</MenuItem>
                                  <MenuItem key={3} value={3}>No CPA +1</MenuItem>
                                  <MenuItem key={7} value={7}>No CPA +2</MenuItem>
                                  <MenuItem key={4} value={4}>No CPC</MenuItem>
                                  <MenuItem key={5} value={5}>No CPC -1</MenuItem>
                                  <MenuItem key={6} value={6}>No CPC +1</MenuItem>
                                  <MenuItem key={8} value={8}>No CPC +2</MenuItem>

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Categorias</InputLabel>
                                <Select notched
                                  id="category"
                                  multiple
                                  value={category}
                                  onChange={changeCategory}
                                  required
                                  fullWidth
                                  label="Categorias"
                                  name="category"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'category',
                                    id: 'category',
                                  }}
                                >
                                  {dependencies.categories.map((item) => (
                                    <MenuItem key={item.id} value={item.nome}>
                                      <ColorCheckbox checked={category.indexOf(item.nome) > -1} />
                                      <ListItemText primary={item.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Técnicos</InputLabel>
                                <Select notched
                                  id="teams"
                                  multiple
                                  value={technicians}
                                  onChange={changeTechnicians}
                                  fullWidth
                                  label="Técnicos"
                                  name="technicians"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'technicians',
                                    id: 'technicians',
                                  }}
                                >

                                  {dependencies.technicians.map((tc) => (
                                    <MenuItem key={tc.id} value={tc.nome}>
                                      <ColorCheckbox checked={technicians.indexOf(tc.nome) > -1} />
                                      <ListItemText primary={tc.nome + " [" + tc.prestadora.nome + " ]"} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>


                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormGroup row>
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.corretiva}
                                    onChange={changeOccurenceTypes} name="corretiva" />}
                                  label="Corretiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.preventiva}
                                    onChange={changeOccurenceTypes} name="preventiva" />}
                                  label="Preventiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.avcb}
                                    onChange={changeOccurenceTypes} name="avcb" />}
                                  label="AVCB"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.pendencia}
                                    onChange={changeOccurenceTypes} name="pendencia" />}
                                  label="Pendência"
                                />
                              </FormGroup>

                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={10}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      rowsPerPageOptions={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={2}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justify="baseline"
                  alignItems="flex-start"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >

                  </Grid>

                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
